(function () {
  if (window.__lushiesInit) return;
  window.__lushiesInit = true;

  function reveal() {
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.12 });
      document.querySelectorAll('.lushies-reveal:not(.is-in)').forEach(function (el) { io.observe(el); });
    } else {
      document.querySelectorAll('.lushies-reveal').forEach(function (el) { el.classList.add('is-in'); });
    }
  }

  // Fixierte Leiste: erst zeigen, wenn der Hero-Button weggescrollt ist,
  // und wieder ausblenden, sobald die Buttons im Call to Action sichtbar sind.
  function stickyBar() {
    var bar = document.querySelector('[data-lushies-bar]');
    if (!bar) return;
    var anchor = document.querySelector('[data-lushies-hero-btn]') || document.querySelector('[data-lushies-hero]');
    var ticking = false;
    function update() {
      ticking = false;
      var vh = window.innerHeight;
      var show = anchor ? anchor.getBoundingClientRect().bottom < 0 : window.scrollY > vh * 0.6;
      if (show) {
        document.querySelectorAll('[data-lushies-cta-buttons]').forEach(function (el) {
          var r = el.getBoundingClientRect();
          if (r.top < vh && r.bottom > 0) show = false;
        });
      }
      bar.classList.toggle('lushies-bar--visible', show);
    }
    function onScroll() { if (!ticking) { ticking = true; window.requestAnimationFrame(update); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  }

  // Welle des fixierten Hintergrunds: sinkt nach unten weg, bevor der gelbe
  // Call to Action ins Bild kommt (kein harter Schnitt durch die blaue Fläche).
  function pushWave() {
    var wave = document.querySelector('.lushies-backdrop__wave');
    if (!wave) return;
    var stop = document.querySelector('.lushies-cta') || document.querySelector('[class*="shopify-section-group-footer-group"]');
    if (!stop) return;
    var ticking = false;
    function update() {
      ticking = false;
      var h = wave.offsetHeight || 1;
      var d = stop.getBoundingClientRect().top - window.innerHeight;
      var t = Math.max(0, Math.min(h + 4, h - d));
      wave.style.transform = t > 0 ? 'translateY(' + t + 'px)' : '';
    }
    function onScroll() { if (!ticking) { ticking = true; window.requestAnimationFrame(update); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  }

  function init() { reveal(); stickyBar(); pushWave(); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Theme-Editor: neu geladene Sections sofort sichtbar machen
  document.addEventListener('shopify:section:load', function () {
    document.querySelectorAll('.lushies-reveal').forEach(function (el) { el.classList.add('is-in'); });
    reveal();
  });
})();
